/**
 * Le verdict et les trois faits qui l'accompagnent.
 *
 * C'est la réponse à la question posée par l'application. Ce bloc est
 * dimensionné pour tenir dans le premier écran d'un téléphone : tout ce qui
 * vient ensuite n'est que du détail.
 */
import { directionFrom, forceWord, formatClock } from '../../core/format';
import type { DisplayedVerdict, NearbyFires } from '../../state/selectors';
import type { AppState } from '../../state/store';
import { html, type Html } from '../html';

export function verdictCard(
  state: AppState,
  _fires: NearbyFires,
  displayed: DisplayedVerdict,
  now: number,
): Html {
  /*
   * La raison est désormais construite en amont, dans les sélecteurs : c'est là
   * que se décide si c'est la mesure, le nez ou la proximité d'un feu qui
   * l'emporte. La carte se contente de l'afficher.
   */
  const reason = displayed.reason;
  const weather = state.weather;
  const lastNose = state.nose[0];

  const windFact =
    weather && weather.direction !== null
      ? html`<dd>
          Vient ${directionFrom(weather.direction)}
          <span class="fact-note">${forceWord(weather.speed)}</span>
        </dd>`
      : html`<dd>-<span class="fact-note">pas d'info</span></dd>`;

  const temperatureFact =
    weather && weather.temperature !== null
      ? html`<dd>
          ${Math.round(weather.temperature)}°
          <span class="fact-note"
            >${weather.temperatureMax !== null
              ? `jusqu'à ${Math.round(weather.temperatureMax)}° aujourd'hui`
              : ''}</span
          >
        </dd>`
      : html`<dd>-<span class="fact-note">pas d'info</span></dd>`;

  const noseFact = lastNose
    ? html`<dd>
        ${lastNose.smoke ? 'Fumée' : 'Rien'}
        <span class="fact-note">à ${formatClock(lastNose.at, now)}</span>
      </dd>`
    : html`<dd>Rien noté<span class="fact-note">dis-le ci-dessous</span></dd>`;

  return html`
    <section aria-labelledby="verdict-title">
      <h2
        class="verdict"
        id="verdict-title"
        style="--verdict-color: var(${displayed.colorVar})"
      >
        ${displayed.title}
      </h2>
      <p class="verdict-reason">${reason}</p>
      <p class="verdict-place">
        ${state.position.label || '-'}${displayed.verdict.source
          ? ` (${displayed.verdict.source})`
          : ''}
      </p>

      <dl class="facts">
        <div><dt>Vent</dt>${windFact}</div>
        <div><dt>Dehors</dt>${temperatureFact}</div>
        <div><dt>Ton nez</dt>${noseFact}</div>
      </dl>
    </section>
  `;
}
